import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import { AuthProvider } from './context/AuthContext';
import { AssessmentSessionProvider } from './context/AssessmentSessionContext';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AssessmentSessionProvider>
          <AppRoutes />
        </AssessmentSessionProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
